(function () {

	'use strict';

	/*global $:true */

	let cologicSortByTags = {

		initSortByTags: function () {
            this.parseBikeFilter(true);
			// let that = this;
            //
			// this.showToTop();
			// this.setBurger();
			// this.enableAccordion();
			// // this.navigationHandling();
			// // this.setYoutubeBox();
            //
			// $('.toTopWrapper').click(this.pageToTop);
			// // $(window).scroll(function () {
			// // 	that.setBackgroundImages();
			// // 	that.showToTop();
			// // });
			// // setTimeout(function () {
			// // 	that.setBackgroundImages()
			// // }, 1500);
            //
			// this.equalHeight();
            this.enableTagButtonsForDataTags(this.identifyDataTags(['.bikeBoxCrawler']));

		},


        identifyDataTags: function (_classes) {
            if (typeof(_classes) != 'undefined' && _classes != null && _classes !== ''){
                let dataTags = [];
                _classes.forEach((_class)=>{
                    $(_class).each(function(){
                        let json_data = $(this).data();
                        for(let i in json_data){
                            // console.log(i);
                            if(typeof(dataTags[i]) != 'undefined'){
                                dataTags[i].push(json_data [i]);
                                // dataTags[i].push(json_data[i].trim().split(' '));
                            }else{
                                dataTags[i] = [];
                                dataTags[i].push(json_data[i]);
                                // dataTags[i].push(json_data[i].trim().split(' '));
                            }
                        }
                    });
                });
                // console.log(dataTags);

                return dataTags;
            }else{
                return [];
            }
		},



        enableTagButtonsForDataTags: function (_dataTags) {
            // console.log(_dataTags);
            let out = '';
            // out += '<h3 class="tagSectionHead">Aktuelle Kategorien (zum ein-/ausblenden klicken)</h3>';
            out += '<div class="tagSection pt-2">';
            let procArray = [];
            let tempKat = '';
            for(let i in _dataTags){
                if(tempKat != i && tempKat != ''){
                    out += '<br/>';
                }
                tempKat = i;

                procArray[i] = [];
                // console.log(i);
                // console.log(_dataTags[i]);
                // console.log(i);
                if(i != 'name'){
                    _dataTags[i].forEach((selectTag) =>{
                        // console.log(i);
                            // selectTag.forEach((tag) => {
                                if(typeof(procArray[i][selectTag]) == 'undefined') {
                                    let tag = selectTag;
                                    if(tag != ''){
                                        // console.log('TAG:');
                                        // console.log(tag);
                                        procArray[i][tag] = 1;
                                        // let fineTag = tag.charAt(0).toUpperCase()  + tag.slice(1)
                                        out += '<div class="btn tagBtn" data-wert="' + tag + '" data-kategorie="' + i + '">' + tag + '</div>';
                                    }
                                }
                            // });
                    });
                    // out += '</div>';
                }
            }
            out += '</div>';
            // console.log(out);
            // $('.crawlerContainer ').prepend(out);
            $('.innerCrawler').prepend(out);
            // if (typeof(_dataTags) != 'undefined' && _dataTags != null && _dataTags !== '' && _dataTags.length > 0){
            //     _dataTags.forEach((_dataTag)=>{
            //         console.log(_dataTag);
            //     });
            // }
            $('.tagBtn').each(function (){
                $(this).bind('click', function(){
                    let that = this;
                    let kategorieActive = [];
                    kategorieActive['modelljahr'] = [];
                    kategorieActive['fahrradtyp'] = [];
                    let kategorie = [];
                    let wert = [];
                    $(this).toggleClass('active');

                    // $(this).removeClass('active');
                    $('.bikeBoxCrawler').each(function(){
                        // if($(this).data(kategorie).indexOf(wert) != -1){
                            // $(this).toggleClass(kategorie);
                            // $(this).toggleClass(wert);
                            $(this).addClass('active');
                        // }
                    });

                    $('.tagBtn').each(function (){
                        if($(this).hasClass('active')){
                            kategorie = $(this).data('kategorie');
                            kategorieActive[kategorie].push($(this).data('wert'));
                            // console.log('KAT');
                            // console.log(kategorie);
                            // console.log('WERT');
                            // console.log(wert);
                            let found = false;
                            // $('.bikeBoxCrawler').each(function(){
                            //     if($(this).data(kategorie) != wert){
                            //     // if($(this).data(kategorie).indexOf(wert) != -1){
                            //         // $(this).toggleClass(kategorie);
                            //         // $(this).toggleClass(wert);
                            //         $(this).removeClass('active');
                            //         // $(this).parent().parent().addClass('active');
                            //     }
                            // });
                        }

                    });
                    // console.log(kategorieActive['modelljahr']);
                    // console.log(kategorieActive['fahrradtyp']);

                    $('.bikeBoxCrawler').each(function(){
                        if((kategorieActive['modelljahr'].length < 1 ||kategorieActive['modelljahr'].includes($(this).data('modelljahr'))) && (kategorieActive['fahrradtyp'].length< 1 || kategorieActive['fahrradtyp'].includes($(this).data('fahrradtyp')))){
                        // if(!wert.includes($(this).data(kategorie))){
                        // if($(this).data(kategorie) != wert){
                            // if($(this).data(kategorie).indexOf(wert) != -1){
                            // $(this).toggleClass(kategorie);
                            // $(this).toggleClass(wert);
                            $(this).addClass('active');
                            // $(this).parent().parent().addClass('active');
                        }else{
                            $(this).removeClass('active');
                        }
                    });

                    // let kategorie = $(this).data('kategorie');
                    // let wert = $(this).data('wert');
                    // let found = false;
                    // $('.bikeBoxCrawler').each(function(){
                    //     if($(this).data(kategorie).indexOf(wert) != -1){
                    //         found = true;
                    //         // $(this).toggleClass(kategorie);
                    //         // $(this).toggleClass(wert);
                    //         if($(that).hasClass('active')) {
                    //             $(this).parent().parent().removeClass('active');
                    //             // $(this).removeClass('active');
                    //         }else{
                    //             $(this).parent().parent().addClass('active');
                    //             // $(this).addClass('active');
                    //         }
                    //     }
                    // });
                    // if(found){
                    //     $(this).toggleClass('active');
                    // }



                })
            });
		},


        parseBikeFilter: function(_start ) {
            // console.log('inSort');
            _start = _start || false;
            let filter = document.getElementById('bikeFilter');
            if(!filter) return;
            if(_start == true){
                // console.log('sortFirst');

                let parent = '.bikeContent';
                let item = '.bikeBoxCrawler';
                let selectedValue = filter.options[filter.selectedIndex];
                let values = selectedValue.value.split("_");
                let tag = values[0];
                let order = values[1];
                this.sortByDataTag(parent, item, tag, order);

            }
            filter.addEventListener('change', function() {
                // console.log('change');

                let parent = '.bikeContent';
                let item = '.bikeBoxCrawler';
                let selectedValue = filter.options[filter.selectedIndex];
                // console.log(selectedValue);
                let values = selectedValue.value.split("_");
                let tag = values[0];
                let order = values[1];
                // console.log(tag);
                // console.log(order);

                cologic.sortByDataTag(parent, item, tag, order);
                //alle Referenten bei Anzeige-Änderung einklappen
                // $('.vi-uf-referentenBox .singleBoxInner').accordion( "option", "active", false );

            });
        },


        sortByDataTag: function(_parent, _item, _tag, _order) {
            // console.log(_parent);
            // console.log(_item);
            // console.log(_tag);
            // console.log(_order);
            let sortTag = _tag;
            switch(_order) {
                case "desc":
                    // $(_parent + ' ' + _item).sort().appendTo(_parent);
                    $(_parent + ' ' + _item).sort(function(a, b) {
                        return ($(b).data(sortTag)) > ($(a).data(sortTag)) ? 1 : -1;
                    }).appendTo($(_parent));
                    // $(_parent + ' ' + _item).sort((a, b) => $(a).data(sortTag) < $(b).data(sortTag)).appendTo($(_parent));
                    // $(_parent + ' ' + _item).sort(this.sort_up).appendTo(_parent);
                    // console.log('a');

                    break;
                case "asc":
                    // $(_parent + ' ' + _item).sort().appendTo(_parent);
                    $(_parent + ' ' + _item).sort(function(a, b) {
                    return ($(b).data(sortTag)) < ($(a).data(sortTag)) ? 1 : -1;
                }).appendTo($(_parent));
                    // $(_parent + ' ' + _item).sort((a, b) => $(a).data(sortTag) > $(b).data(sortTag)).appendTo($(_parent));
                    // console.log($(_parent + ' ' + _item).sort((a, b) => $(a).data(sortTag) > $(b).data(sortTag)));

                    // $(_parent + ' ' + _item).sort(this.sort_down).appendTo(_parent);
                    break;
            }


        },


        sort_up: function(a, b) {
            return ($(b).data(sortTag)) < ($(a).data(sortTag)) ? 1 : -1;
        },

        sort_down: function(a, b) {
            return ($(b).data(sortTag)) > ($(a).data(sortTag)) ? 1 : -1;
        },



};

	//------------------------------------

	//gemeinsam verfügbar machen
	if (typeof (cologic) === 'undefined')
		window.cologic = {};
	$.extend(cologic, cologicSortByTags);
}());
